
/// <amd-module name="Environments/CreatePanel/Components/EditResourceComponent" />
import * as React from "react";
import { EnvironmentResourceType, EnvironmentResource } from "DistributedTask/Client/Contracts/TaskAgent";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import * as Resources from "Environments/CreatePanel/Resources";
import { EnvironmentBaseComponent, IEnvironmentBaseComponentProperties, IEnvironmentBaseComponentState } from "Environments/EnvironmentsCommon/EnvironmentBaseComponent";
import { AddResourceComponent } from "Environments/CreatePanel/Components/AddResourceComponent";

interface IEditResourceState extends IEnvironmentBaseComponentState {
    environmentName?: string;
    environmentId: number | undefined | null;
    createResourceSignal: boolean;
}

interface IEditResourceProperties extends IEnvironmentBaseComponentProperties {
    onResourceCreated: () => void;
    onDismissPanel: () => void;
    resourceType: EnvironmentResourceType;
    resource: EnvironmentResource;
    properties?: { [key: string]: any };
    instanceId: string;
    environmentId: number;
    environmentName?: string;
}

export class EditResourceComponent extends EnvironmentBaseComponent<IEditResourceProperties, IEditResourceState> {

    public getInstanceId(context: IVssComponentContext): string {
        return this.props.instanceId;
    }

    constructor(props: IEditResourceProperties, context: IVssComponentContext) {
        super(props, context);
        this.state = {
            errorMessages: {},
            environmentId: undefined,
            createResourceSignal: false
        };
    }

    public render(): JSX.Element {
        return (<AddResourceComponent
            onResourceCreated={this.props.onResourceCreated}
            onResourceCreationFailed={this._onResourceCreationFailed}
            onDismissPanel={this.props.onDismissPanel}
            instanceId={this._instanceId}
            onCreateButtonClick={this._onCreateButtonClick}
            resourceType={this.props.resourceType}
            environmentId={this.props.environmentId}
            environmentName={this.props.environmentName}
            isAddEnvironmentView={false}
            isEdit={true}
            resource={this.props.resource}
            properties={this.props.properties}
            createResourceSignal={this.state.createResourceSignal}
        />);
    }

    private _onCreateButtonClick = () => {
        this.setState({ createResourceSignal: true });
    }


    private _onResourceCreationFailed = (): void => {
        this.setState({ createResourceSignal: false });
    }
}

VssComponent.register("editResources", EditResourceComponent);
